/**
 * Kleine lijn-iconen in de huisstijl, als vervanging van emoji.
 *
 * Emoji worden per besturingssysteem anders getekend (Apple, Windows en Android
 * hebben elk een eigen set), zijn altijd meerkleurig en negeren de huisstijl.
 * Deze iconen erven `currentColor` en de tekstgrootte, zodat ze meelopen met de
 * kleur en het formaat van de tekst ernaast.
 */
import React from "react";

type IconProps = {
  size?: number | string;
  strokeWidth?: number;
  className?: string;
  style?: React.CSSProperties;
};

function base(size: number | string = "1em", strokeWidth = 1.75) {
  return {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    "aria-hidden": true,
    focusable: false,
  };
}

/** Prijskaartje — voor acties en kortingen. */
export function TagIcon({ size, strokeWidth, className, style }: IconProps) {
  return (
    <svg {...base(size, strokeWidth)} className={className} style={{ flexShrink: 0, ...style }}>
      <path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0l-7.2-7.2A2 2 0 0 1 2.8 12V4.8A2 2 0 0 1 4.8 2.8H12a2 2 0 0 1 1.4.6l7.2 7.2a2 2 0 0 1 0 2.8Z" />
      <circle cx="7.8" cy="7.8" r="1.3" fill="currentColor" stroke="none" />
    </svg>
  );
}

/** Vinkje — bevestigingen. */
export function CheckIcon({ size, strokeWidth, className, style }: IconProps) {
  return (
    <svg {...base(size, strokeWidth)} className={className} style={{ flexShrink: 0, ...style }}>
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}

/** Bestelbus — verzending. */
export function TruckIcon({ size, strokeWidth, className, style }: IconProps) {
  return (
    <svg {...base(size, strokeWidth)} className={className} style={{ flexShrink: 0, ...style }}>
      <path d="M2 7.5h11v9H2z" />
      <path d="M13 10.5h4l3 3v3h-7z" />
      <circle cx="6" cy="18" r="1.8" />
      <circle cx="16.5" cy="18" r="1.8" />
    </svg>
  );
}

/** Winkeltas — lege winkelwagen, ontbrekende afbeelding. */
export function BagIcon({ size, strokeWidth, className, style }: IconProps) {
  return (
    <svg {...base(size, strokeWidth)} className={className} style={{ flexShrink: 0, ...style }}>
      <path d="M5 7h14l-1.2 13.2a1 1 0 0 1-1 .8H7.2a1 1 0 0 1-1-.8Z" />
      <path d="M9 7V5.5a3 3 0 0 1 6 0V7" />
    </svg>
  );
}
